import { createContext, Dispatch, ReactElement, SetStateAction, useState } from "react";
import { localState } from "../services/LocalState";
import { AtendimentoType } from "../types/AtendimentoType";
import { TipoAtendimentoType } from "../types/TipoAtendimentoType";

interface ChatAtendenteContextProps{
  openBtnChat: boolean;
  setOpenBtnChat: Dispatch<SetStateAction<boolean>>;
  openModalChat: boolean;
  setOpenModalChat: Dispatch<SetStateAction<boolean>>;
  modoVisualizacao: string;
  setModoVisualizacao: Dispatch<SetStateAction<string>>;
  handleModoVisualizacao: (modo:string) => void;
  atendimentoAtivo: AtendimentoType;
  setAtendimentoAtivo: Dispatch<SetStateAction<AtendimentoType>>;
  tiposAtendimento: TipoAtendimentoType[];
  setTiposAtendimento: Dispatch<SetStateAction<TipoAtendimentoType[]>>;
}

export const ChatAtendenteContext = createContext({} as ChatAtendenteContextProps);

export const ChatAtendenteContextProvider = ({ children }: { children: ReactElement }) => {
    const [openBtnChat, setOpenBtnChat] = useState<boolean>(localState.getLocalState("openBtnChat") === "true");
    const [openModalChat, setOpenModalChat] = useState<boolean>(false);
    const [modoVisualizacao, setModoVisualizacao] = useState<string>('default');
    const [atendimentoAtivo, setAtendimentoAtivo] = useState<AtendimentoType>({} as AtendimentoType)
    const [tiposAtendimento, setTiposAtendimento] = useState<TipoAtendimentoType[]>([] as TipoAtendimentoType[])

    const handleModoVisualizacao = (modo:string) => {
      switch(modo){
        case 'historico':
        case 'criar_atendimento':
        case 'chat':
          setModoVisualizacao(modo);
          break;
        default:
          setModoVisualizacao('default');
          break;
      }
    }

    return (
        <ChatAtendenteContext.Provider
            value={{
              openBtnChat,
              setOpenBtnChat,
              openModalChat,
              setOpenModalChat,
              modoVisualizacao,
              setModoVisualizacao,
              handleModoVisualizacao,
              atendimentoAtivo,
              setAtendimentoAtivo,
              tiposAtendimento,
              setTiposAtendimento,
            }}
        >
            {children}
        </ChatAtendenteContext.Provider>
    );
};
